import ErrorMessage from "../../components/ErrorMessage";
import BrandsPage from "../../components/BrandsPage";
import BrandsPageSkeleton from "../../components/BrandsPage/BrandsPageSkeleton";
import PropTypes from "prop-types";

const BrandsPageContainer = ({ categoryError, groups, ...rest }) => {
  if (categoryError) {
    return <ErrorMessage {...categoryError} />;
  }

  if (groups.length === 0) {
    return <BrandsPageSkeleton />;
  }

  return <BrandsPage groups={groups} {...rest} />;
};

BrandsPageContainer.propTypes = {
  categoryError: PropTypes.object,
  groups: PropTypes.array
};

export default BrandsPageContainer;
